import { GoogleLatLng } from '../components/Wizard/Step2/components/Map/types'
import { isEmpty } from './stringUtils'

export const getFormattedAddress = (
    zip: string | undefined,
    city: string | undefined,
    street: string | undefined,
    regNo: string | undefined,
    sequentialNo: string | undefined,
    useCountry: boolean = true
) => {
    if (zip === undefined) return ''
    if (city === undefined) return ''
    var houseNum = sequentialNo === undefined ? regNo : regNo + (!isEmpty(sequentialNo) ? '/' + sequentialNo : '')
    return (
        (street ?? '') +
        (regNo !== undefined ? ' ' + houseNum + ', ' : '') +
        zip +
        ' ' +
        city +
        (useCountry === true ? ', CZ' : '')
    )
}

const rad = (x: number) => {
    return (x * Math.PI) / 180
}

export const getDistance = (p1: GoogleLatLng, p2: GoogleLatLng) => {
    const R = 6378137 // Earth’s mean radius in meter
    const dLat = rad(p2.lat - p1.lat)
    const dLong = rad(p2.lng - p1.lng)
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    const d = R * c
    return d // returns the distance in meter
}
